import React from 'react';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { Checkbox } from '../ui/checkbox';
import { RadioGroup, RadioGroupItem } from '../ui/radio-group';

const QUANTITY_RANGES = [
  { value: '10-25', id: 'qty-10-25', label: '10-25' },
  { value: '26-50', id: 'qty-26-50', label: '26–50' },
  { value: '51-75', id: 'qty-51-75', label: '51–75' },
  { value: '76-100', id: 'qty-76-100', label: '76–100' },
  { value: '100+', id: 'qty-100-plus', label: '100+' },
];

export const PrintDetailsSection = ({ formData, set }) => (
  <div className="space-y-4">
    <h3 className="text-xl font-semibold text-charcoal-ink border-b border-stone-taupe/20 pb-2">SECTION 6: PRINT DETAILS (IF APPLICABLE)</h3>

    <div className="bg-soft-linen p-4 rounded-lg border border-stone-taupe/20">
      <p className="text-charcoal-ink text-sm">
        <strong>Pricing Note:</strong> Bundle pricing includes design and up to 12 printed pieces per included item. Additional quantities are available for an added fee. Custom quotes are provided for large orders.
      </p>
    </div>

    <div>
      <Label className="text-charcoal-ink mb-3 block">Quantity Needed for Each Item *</Label>
      <RadioGroup value={formData.quantityRange} onValueChange={(value) => set('quantityRange', value)}>
        {QUANTITY_RANGES.map((q) => (
          <div key={q.value} className="flex items-center space-x-2">
            <RadioGroupItem value={q.value} id={q.id} />
            <Label htmlFor={q.id} className="text-charcoal-ink font-normal cursor-pointer">{q.label}</Label>
          </div>
        ))}
      </RadioGroup>
    </div>

    <div>
      <Label htmlFor="shippingAddress" className="text-charcoal-ink">Shipping Address *</Label>
      <Textarea
        id="shippingAddress"
        required
        value={formData.shippingAddress}
        onChange={(e) => set('shippingAddress', e.target.value)}
        className="bg-white border-stone-taupe/20 min-h-[100px]"
      />
    </div>

    <div className="flex items-start space-x-3 bg-warm-ivory p-4 rounded-lg border border-stone-taupe/20">
      <Checkbox
        id="pricingAdjustment"
        checked={formData.agreedToPricingAdjustment}
        onCheckedChange={(checked) => set('agreedToPricingAdjustment', checked)}
        required
      />
      <Label htmlFor="pricingAdjustment" className="text-charcoal-ink font-normal cursor-pointer leading-relaxed">
        I understand that final pricing may adjust based on quantity and print specifications, and that production will not begin until pricing is approved.
      </Label>
    </div>
  </div>
);
